<section class="security-card" automation-id="security_tab">
    <h3 class="security-card__title">{{ 'UserProfile.Security.header' | translate }}</h3>
    <p class="security-card__description">{{ 'UserProfile.Security.description' | translate }}</p>

    <div class="methods-table" role="table">
        <div class="methods-table__header" role="row">
            <span role="columnheader">{{ 'UserProfile.Security.methodColumn' | translate }}</span>
        </div>

        <div class="methods-table__row" role="row" automation-id="security_row_password">
            <div class="methods-table__label">
                <p-icon name="lock" color="base-dark"></p-icon>
                <div>
                    <div>{{ 'UserProfile.Security.password' | translate }}</div>
                    <div class="methods-table__sub" *ngIf="mfaState?.lastPasswordChange as changed">
                        {{ 'UserProfile.Security.passwordLastChanged' | translate }} {{ changed | date: 'd MMM yyyy' }}
                    </div>
                </div>
            </div>
            <div class="methods-table__actions">
                <p-link (onClick)="changePassword.emit()" automation-id="security_change_password">
                    {{ 'UserProfile.Security.change' | translate }}
                </p-link>
            </div>
        </div>

        <div class="methods-table__error" role="row" *ngIf="loadError" automation-id="security_load_error">
            <p-icon name="alert-circle" color="status-default-high" size="sm"></p-icon>
            <span>{{ loadError | translate }}</span>
        </div>

        <ng-container *ngIf="mfaState">
            <div
                class="methods-table__row"
                role="row"
                *ngFor="let row of rows; trackBy: trackByMethod"
                [attr.automation-id]="'security_row_' + row.key"
            >
                <div class="methods-table__label">
                    <p-icon [name]="row.icon" color="base-dark"></p-icon>
                    <span>{{ 'UserProfile.Security.Methods.' + row.key + '.Name' | translate }}</span>
                    <p-icon
                        *ngIf="row.isDefault"
                        class="methods-table__default"
                        name="check-circle"
                        color="status-default-success"
                        [matTooltip]="'UserProfile.Security.defaultTooltip' | translate"
                    ></p-icon>
                </div>
                <div class="methods-table__actions">
                    <p-link
                        *ngIf="row.canMakeDefault"
                        (onClick)="makeDefault.emit(row.method)"
                        [attr.automation-id]="'security_make_default_' + row.key"
                    >
                        {{ 'UserProfile.Security.makeDefault' | translate }}
                    </p-link>
                    <p-link *ngIf="row.canRemove" (onClick)="onRemove(row.method)" [attr.automation-id]="'security_remove_' + row.key">
                        {{ 'UserProfile.Security.remove' | translate }}
                    </p-link>
                </div>
            </div>
        </ng-container>
    </div>

    <p-link *ngIf="canAddMethod" class="add-method" (onClick)="onAddMethod()" automation-id="security_add_method">
        <p-icon name="plus" color="functional-default" size="sm"></p-icon>
        {{ 'UserProfile.Security.addMethod' | translate }}
    </p-link>
</section>
